import { render, staticRenderFns } from "./LmQmsProcesses.vue?vue&type=template&id=67c85b64&"
import script from "./LmQmsProcesses.vue?vue&type=script&lang=js&"
export * from "./LmQmsProcesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports